export default "__VITE_ASSET__CTELUTnE__"